import { API_ROOT } from '../constants'
import api from '../utils/api'

export const reportSite = (data, config) => {
  return api.post(`${API_ROOT}/v3/support/report-site`, data, config)
}
